export const MENU = [
  {
    id: "appetizers",
    label: "Appetizers",
    note: "Steamed, spiced & fried to order",
    items: [
      { name: "Idly (3 pcs)", desc: "Steamed rice cakes", price: "9.00" },
      { name: "Kanchipuram Idly (3 pcs)", desc: "Rice cakes spiced with crushed black pepper, ginger & green chilies", price: "9.00" },
      { name: "Rava Idly (3 pcs)", desc: "Cream-of-wheat cakes with ginger, carrots & green chilies", price: "9.00" },
      { name: "Mixed Idly (3 pcs)", desc: "Idly, Rava Idly & Kanchipuram Idly — one of each", price: "9.00" },
      { name: "Idly Vada", desc: "2 pc Idly with 1 pc crispy vada", price: "9.00" },
      { name: "Ghee Idly", desc: "Steamed rice cakes roasted with ghee", price: "10.00" },
      { name: "Masala Idly", desc: "Cubed rice cakes tempered with homemade seasoning", price: "10.00", spice: 1 },
      { name: "Sambhar Idly", desc: "10 small rice cakes soaked in sambhar", price: "10.00" },
      { name: "Rasam Idly", desc: "10 small rice cakes soaked in rasam", price: "10.00", spice: 2 },
      { name: "Podi Idly", desc: "Mini rice cakes fried in ghee & tossed with spicy masala powder", price: "10.00", spice: 1 },
      { name: "Masala Vada", desc: "Flat fried donuts of chickpea, onions, chilies, ginger & spices", price: "9.00" },
      { name: "Sambhar Vada", desc: "Crispy lentil donuts dipped in sambhar, onions, tomatoes & curry-leaf powder", price: "10.00" },
      { name: "Rasam Vada", desc: "Crispy lentil donuts dipped in rasam", price: "10.00", spice: 2 },
      { name: "Medu Vada", desc: "Classic crispy lentil donuts", price: "9.00" },
      { name: "Palak Pakora (Half / Full)", desc: "Spinach with chickpea batter & spices, deep-fried", price: "7.00 / 12.00" },
      { name: "Onion Pakora (Half / Full)", desc: "Sliced onions in spiced chickpea batter, deep-fried", price: "7.00 / 12.00" },
      { name: "Mirchi Bajji (Half / Full)", desc: "Hot chilies stuffed with tangy paste, dipped in gram flour & deep-fried", price: "7.00 / 12.00", spice: 3 },
      { name: "Cut Mirchi (Half / Full)", desc: "Mirchi bajji cut into cubes & double fried", price: "7.00 / 12.00", spice: 3 },
      { name: "Mysore Bonda", desc: "Crisp, soft dumplings from fermented maida & yogurt batter", price: "13.00" },
      { name: "Punugulu", desc: "Crisp, soft dumplings from fermented rice-lentil batter", price: "13.00" },
    ],
  },
  {
    id: "chaat",
    label: "Chaat Special",
    note: "Street classics, elevated",
    items: [
      { name: "Samosa (2 pcs)", desc: "Fried savory pastry filled with spiced potatoes", price: "7.00" },
      { name: "Samosa Chat", desc: "Samosa topped with hot chickpea sauce, onions, mint, garlic & tamarind", price: "10.00" },
      { name: "Pani Poori", desc: "Crispy puffed wafers with spicy mint water, chutney & potatoes", price: "10.00", spice: 1 },
      { name: "Sev Poori", desc: "Puffed wafers with potato, onion, chickpeas, mint & tamarind", price: "10.00" },
      { name: "Dahi Poori", desc: "Fried wafers with potatoes, onions, chutneys, sev & yogurt", price: "10.00" },
      { name: "Papdi Chat", desc: "Crisp wafers with boiled potatoes, chickpeas, yogurt, chutneys & chaat masala", price: "10.00" },
      { name: "Pav Bhaji", desc: "Mashed veggies with coriander & diced onions, hot buttered pav", price: "10.00", spice: 1 },
      { name: "Dahi Vada", desc: "Fried lentil donuts soaked in creamy yogurt", price: "10.00" },
    ],
  },
  {
    id: "bread",
    label: "Bread Corner",
    note: "Puffed, soft & served with curries",
    items: [
      { name: "Poori Bhaji", desc: "Deep-fried whole wheat bread with mildly spiced mashed potatoes", price: "14.00" },
      { name: "Poori Koorma", desc: "Deep-fried whole wheat bread with potato & green peas curry", price: "14.00" },
      { name: "Chole Poori", desc: "Deep-fried whole wheat bread with chickpea curry", price: "14.00" },
      { name: "Chole Bhatura", desc: "Deep-fried all-purpose bread with chickpea curry", price: "14.00" },
      { name: "Chapathi with Curry & Dal", desc: "3 chapathis with 2 vegetable curries, dal, pickle & pakora", price: "14.00" },
    ],
  },
  {
    id: "dosa",
    label: "Dosa Corner",
    note: "Thin crepe of fermented rice-lentil batter",
    items: [
      { name: "Plain Dosa", desc: "The classic golden crepe", price: "12.00" },
      { name: "Butter / Ghee Dosa", desc: "Roasted with butter or ghee", price: "12.50" },
      { name: "Masala Dosa", desc: "Filled with mildly spiced mashed potatoes & onions", price: "13.00" },
      { name: "Butter / Ghee Masala Dosa", desc: "Masala dosa roasted with butter or ghee", price: "13.50" },
      { name: "Bangalore Masala Dosa", desc: "Homemade mild channa-dal spicy powder & mashed potatoes", price: "14.00", spice: 1 },
      { name: "Bangalore Butter/Ghee Masala Dosa", desc: "Bangalore masala roasted with butter or ghee", price: "14.50", spice: 1 },
      { name: "Bangalore Onion-Chilli Masala Dosa", desc: "Spicy channa-dal powder, onions, chillies & mashed potatoes", price: "15.00", spice: 2 },
      { name: "Mysore Plain Dosa", desc: "Crepe spread with spicy homemade sauce", price: "13.00", spice: 2 },
      { name: "Butter / Ghee Mysore Plain Dosa", desc: "Mysore spread roasted with butter or ghee", price: "13.50", spice: 2 },
      { name: "Mysore Masala Dosa", desc: "Spicy homemade sauce with mild spiced mashed potatoes", price: "14.00", spice: 2 },
      { name: "Butter / Ghee Mysore Masala Dosa", desc: "Mysore masala roasted with butter or ghee", price: "14.50", spice: 2 },
      { name: "Cheese Mysore Plain Dosa", desc: "Mysore spread with cheddar cheese", price: "14.00", spice: 2 },
      { name: "Cheese Mysore Masala Dosa", desc: "Mysore spread, cheddar & mashed potato filling", price: "15.00", spice: 2 },
      { name: "Chilli Masala Dosa", desc: "Topped with green chillies & filled with mashed potato", price: "13.50", spice: 2 },
      { name: "Black Channa Masala Dosa", desc: "Filled with mashed potato & brown chickpea", price: "13.50" },
      { name: "Black Channa Onion-Chilli Masala Dosa", desc: "Brown chickpea filling topped with onions & chillies", price: "14.50", spice: 1 },
      { name: "Onion Dosa", desc: "Crepe topped with onions", price: "12.50" },
      { name: "Onion Masala Dosa", desc: "Mildly spiced mashed potatoes & onions", price: "13.50" },
      { name: "Onion Chilli Dosa", desc: "Topped with onions & green chillies", price: "13.00", spice: 1 },
      { name: "Onion Chilli Masala Dosa", desc: "Mashed potatoes, onions & chillies", price: "14.00", spice: 1 },
      { name: "Ghee Karam Dosa", desc: "Tossed with spicy powder and ghee", price: "14.00", spice: 2 },
      { name: "Cheese Dosa / Paneer Dosa", desc: "Topped with cheddar cheese or paneer", price: "13.00" },
      { name: "Cheese / Paneer Masala Dosa", desc: "Cheese or paneer with mild spicy mashed potatoes", price: "14.00" },
      { name: "Paper Plain Dosa", desc: "Thin, long, crispy crepe", price: "14.00" },
      { name: "Paper Masala Dosa", desc: "Paper dosa with mildly spiced mashed potatoes", price: "15.00" },
      { name: "Paper Mysore Masala Dosa", desc: "Paper dosa, spicy homemade sauce & mashed potatoes", price: "16.00", spice: 2 },
      { name: "Paper Butter Mysore Masala Dosa", desc: "Roasted with butter, Mysore spread & potato filling", price: "16.50", spice: 2 },
      { name: "Palak Plain Dosa", desc: "Crepe spread with spinach paste", price: "13.00" },
      { name: "Palak Masala Dosa", desc: "Spinach paste with mildly spiced mashed potatoes", price: "14.00" },
      { name: "Cheese Palak Masala Dosa", desc: "Spinach paste, mozzarella & mashed potatoes", price: "15.00" },
      { name: "Palak Paneer Dosa", desc: "Spinach paste topped with Indian cottage cheese", price: "14.00" },
      { name: "Palak Paneer Masala Dosa", desc: "Spinach, paneer & mashed potato filling", price: "15.00" },
      { name: "Spring Dosa", desc: "Filled with spring onions, cabbage & bellpepper masala", price: "14.00" },
      { name: "Pondicherry Plain / Mysore Onion Chilli Dosa", desc: "Spicy homemade sauce, onions & chillies", price: "14.00", spice: 2 },
      { name: "Pondicherry Butter Plain Dosa", desc: "Spicy sauce, onions, chillies, roasted with butter", price: "14.50", spice: 2 },
      { name: "Pondicherry Masala Dosa", desc: "Spicy sauce, onions, chillies & mild mashed potato", price: "15.50", spice: 3 },
      { name: "Pesarattu", desc: "Crepe made with green moong dal", price: "13.50" },
      { name: "Pesarattu with Upma", desc: "Green moong dal crepe filled with upma", price: "15.50" },
      { name: "Onion-Chilli Pesarattu", desc: "Moong dal crepe topped with onion & chillies", price: "14.50", spice: 1 },
      { name: "Amul Cheese Dosa", desc: "Topped with Amul cheese", price: "15.00" },
      { name: "Amul Cheese Masala Dosa", desc: "Amul cheese & mild spiced mashed potato", price: "16.00" },
      { name: "Gongura Masala Dosa", desc: "Spiced gongura paste & mashed potato", price: "14.00", spice: 1 },
      { name: "Gongura Onion Masala Dosa", desc: "Gongura paste, onions & mashed potato", price: "14.50", spice: 1 },
      { name: "Gongura Onion Chilli Masala Dosa", desc: "Gongura, onions, chillies & mashed potato", price: "15.00", spice: 2 },
      { name: "Mint Masala Dosa", desc: "Spiced mint paste & mashed potato", price: "14.00", spice: 1 },
      { name: "Mint Onion Masala Dosa", desc: "Mint paste, onions & mashed potato", price: "14.50", spice: 1 },
      { name: "Mint Onion Chilli Masala Dosa", desc: "Mint, onions, chillies & mashed potato", price: "15.00", spice: 2 },
      { name: "Curry Leaf Masala Dosa", desc: "Spiced curry-leaf powder & mashed potato", price: "14.00", spice: 1 },
      { name: "Curry Leaf Onion Masala Dosa", desc: "Curry-leaf powder, onions & mashed potato", price: "14.50", spice: 1 },
      { name: "Curry Leaf Onion Chilli Masala Dosa", desc: "Curry-leaf powder, onions, chillies & potato", price: "15.00", spice: 2 },
      { name: "Chocolate Dosa", desc: "Crepe spread with chocolate syrup", price: "14.00", tag: "Kids" },
      { name: "Pav Bhaji Masala Dosa", desc: "Crepe spread with pav bhaji masala", price: "14.00", spice: 1 },
      { name: "Mango Ginger Plain Dosa", desc: "Crepe spread with spiced mango-ginger paste", price: "13.00", spice: 1 },
      { name: "Mango Ginger Masala Dosa", desc: "Mango-ginger paste filled with mashed potato", price: "14.00", spice: 1 },
      { name: "Mango Ginger Onion Masala Dosa", desc: "Mango-ginger paste, onions & mashed potato", price: "14.50", spice: 1 },
      { name: "Mango Ginger Onion Chilli Masala Dosa", desc: "Mango-ginger, onions, chillies & mashed potato", price: "15.00", spice: 2 },
    ],
  },
  {
    id: "chef",
    label: "Chef Specials",
    note: "House signatures & Indo-Chinese riffs",
    items: [
      { name: "Dosa Place Special Dosa", desc: "Mint, tomato chutney, curry-leaf powder, potato, onions, chillies & chickpeas", price: "15.00", spice: 3, tag: "Signature" },
      { name: "Schezwan Dosa", desc: "Crepe spread with Schezwan chutney, cut into pieces", price: "13.00", spice: 1 },
      { name: "Noodles Dosa", desc: "Crepe spread with Indo-Chinese noodles", price: "14.00", spice: 1 },
      { name: "Jini Dosa with Amul Cheese", desc: "Schezwan, tomato sauce, veggies, masala & Amul cheese", price: "15.00", spice: 2 },
      { name: "Jini Dosa without Cheese", desc: "Schezwan, tomato sauce, cabbage, carrots, capsicum & masala", price: "13.00", spice: 2 },
      { name: "Mysore with Bangalore Powder Masala Dosa", desc: "Mysore paste & Bangalore powder tossed with potato masala", price: "14.00", spice: 2 },
      { name: "Triple Flavor Masala Dosa", desc: "Mysore, Bangalore & Schezwan — all three spreads", price: "15.00", spice: 2, tag: "Signature" },
      { name: "Mini Tiffin", desc: "1 Idly, 1 Vada, Pongal, Upma, Rava Sheera & Mini Masala Dosa", price: "15.00", tag: "Signature" },
      { name: "Upma Dosa", desc: "Crepe spread with upma, cut into pieces", price: "13.00" },
      { name: "Spicy Upma Dosa", desc: "Mysore paste, Bangalore powder & upma", price: "15.00", spice: 2 },
      { name: "Onion Karam Masala Dosa", desc: "Onion & tomato spicy paste with mashed potatoes", price: "15.00", spice: 2 },
      { name: "Paneer Butter Masala Dosa", desc: "Spread with shredded paneer butter masala curry", price: "15.00" },
      { name: "Paneer Bhurji Dosa", desc: "Spread with paneer bhurji curry", price: "15.00" },
    ],
  },
  {
    id: "rava",
    label: "Rava Specials",
    note: "Lacy crepe of rice flour & cream of wheat",
    items: [
      { name: "Rava Plain Dosa", desc: "Crisp, lacy rava crepe", price: "13.00" },
      { name: "Rava Masala Dosa", desc: "Rava crepe with potato masala", price: "14.00" },
      { name: "Rava Chilli Dosa", desc: "Rava crepe with green chillies", price: "13.50", spice: 1 },
      { name: "Rava Chilli Masala Dosa", desc: "Chilli rava with potato masala", price: "14.50", spice: 1 },
      { name: "Rava Onion Dosa", desc: "Rava crepe with onions", price: "13.50" },
      { name: "Rava Onion Masala Dosa", desc: "Onion rava with potato masala", price: "14.50" },
      { name: "Rava Onion-Chilli Dosa", desc: "Onions & chillies in a lacy crepe", price: "14.00", spice: 1 },
      { name: "Rava Onion-Chilli Masala Dosa", desc: "Onion-chilli rava with masala", price: "15.00", spice: 1 },
      { name: "Rava Cheese Masala Dosa", desc: "Rava crepe, cheddar & potato masala", price: "16.00" },
      { name: "Rava Paneer Masala Dosa", desc: "Rava crepe, paneer & potato masala", price: "16.00" },
      { name: "Rava Mysore Plain Dosa", desc: "Rava crepe with spicy Mysore spread", price: "14.00", spice: 2 },
      { name: "Rava Mysore Masala Dosa", desc: "Mysore rava with potato masala", price: "15.00", spice: 2 },
      { name: "Rava Butter Mysore Masala Dosa", desc: "Butter-roasted Mysore rava with masala", price: "15.50", spice: 1 },
      { name: "Rava Butter Onion-Chilli Coriander Dosa", desc: "Butter rava, onions, chillies & coriander", price: "15.00", spice: 1 },
      { name: "Rava Butter Onion-Chilli Coriander Masala Dosa", desc: "The full house rava experience", price: "16.00", spice: 1 },
    ],
  },
  {
    id: "uttapam",
    label: "Uttapam Specials",
    note: "Thick pancake of fermented lentil & rice dough",
    items: [
      { name: "Plain Uttapam", desc: "Soft, thick & golden", price: "12.00" },
      { name: "Onion Uttapam", desc: "Topped with sweet onions", price: "12.50" },
      { name: "Onion Tomato Uttapam", desc: "Onions & fresh tomato", price: "13.00" },
      { name: "Mixed Vegetable Uttapam", desc: "Garden vegetables pressed in", price: "13.00" },
      { name: "Onion Chilli Tomato Uttapam", desc: "With a gentle kick", price: "13.50", spice: 1 },
      { name: "Onion Chilli Uttapam", desc: "Onions & green chillies", price: "13.00", spice: 1 },
      { name: "Onion-Chilli-Coriander Veg Uttapam", desc: "Fully loaded with coriander & vegetables", price: "14.00", spice: 1 },
    ],
  },
  {
    id: "rice",
    label: "Rice Specials",
    note: "Basmati, tamarind & comfort classics",
    items: [
      { name: "Vegetable Biriyani", desc: "Basmati rice cooked with mixed vegetables & Indian spices", price: "12.00", spice: 2 },
      { name: "Lemon Rice", desc: "Rice tossed with peanuts, lemon juice & spices", price: "11.00", spice: 1 },
      { name: "Tamarind Rice (Pulihora)", desc: "Tamarind sauce, peanuts & herbs", price: "11.00", spice: 1 },
      { name: "Pongal", desc: "Steamed rice mashed with ghee, pepper, jeera, dal & cashews", price: "11.00" },
      { name: "Upma", desc: "Cream of wheat with onion, chillies & tomatoes", price: "11.00" },
      { name: "Yogurt Rice (Half / Full)", desc: "Cooling curd rice", price: "7.00 / 11.00" },
      { name: "South Indian Vegetarian Thali", desc: "Roti or Poori, rice, 2 curries, pickle, papad, rasam, yogurt & sweet", price: "16.00", tag: "Signature" },
    ],
  },
  {
    id: "sides",
    label: "Side Orders",
    note: "Little extras",
    items: [
      { name: "Papad (2)", desc: "", price: "2.00" },
      { name: "Chapathi (1) / Roti (1)", desc: "", price: "2.00" },
      { name: "Idly / Rava Idly", desc: "", price: "3.00" },
      { name: "Kanchipuram Idly (1 pc)", desc: "", price: "3.00" },
      { name: "Vada (1 pc)", desc: "", price: "4.50" },
      { name: "Plain Rice", desc: "", price: "5.00" },
      { name: "Poori / Bhatura", desc: "", price: "3.50" },
    ],
  },
  {
    id: "beverages",
    label: "Beverages",
    note: "Brewed & churned fresh",
    items: [
      { name: "Masala Tea", desc: "Spiced Indian chai", price: "2.00" },
      { name: "Filter Coffee", desc: "South Indian degree coffee, frothed", price: "3.00", tag: "Signature" },
      { name: "Soda / Water", desc: "", price: "1.50" },
      { name: "Thumsup / Limca", desc: "", price: "3.00" },
      { name: "Indian Goli Soda", desc: "The marble-bottle classic", price: "4.00" },
      { name: "Mango / Sweet / Salt Lassi", desc: "Churned yogurt, three ways", price: "5.00" },
      { name: "Badam Milk", desc: "Warm almond milk with saffron", price: "5.00" },
    ],
  },
  {
    id: "desserts",
    label: "Desserts",
    note: "A sweet ending",
    items: [
      { name: "Carrot Halwa", desc: "Slow-cooked carrots, ghee & nuts", price: "5.00" },
      { name: "Rasmalai (2 pcs)", desc: "Soft chenna discs in saffron milk", price: "5.00" },
      { name: "Gulab Jamun (2 pcs)", desc: "Golden, syrup-soaked classics", price: "5.00" },
      { name: "Rava Sheera (Rava Kesari)", desc: "Saffron semolina pudding", price: "5.00" },
    ],
  },
  {
    id: "takeout",
    label: "Takeout Specials",
    note: "8 oz / 16 oz / 32 oz",
    items: [
      { name: "Sambhar", desc: "", price: "3.00 / 5.00 / 10.00" },
      { name: "Peanut Chutney", desc: "", price: "3.00 / 6.00 / 11.00" },
      { name: "Coconut Chutney", desc: "", price: "3.00 / 6.00 / 11.00" },
      { name: "Tomato Chutney", desc: "", price: "3.00 / 7.00 / 13.00" },
      { name: "Any Veg Curry", desc: "", price: "5.00 / 9.00 / 16.00" },
      { name: "Any Paneer Curry", desc: "", price: "— / 14.00 / 25.00" },
      { name: "Idly Batter / Dosa Batter", desc: "Fresh-fermented, take home", price: "— / 3.00 / 6.00" },
    ],
  },
];

export const CATEGORIES = [
  { name: "Dosas", count: "90+ varieties", img: "dosas" },
  { name: "Idlis", count: "Steamed fresh hourly", img: "idlis" },
  { name: "Vadas", count: "Crisp & golden", img: "vadas" },
  { name: "Uttapam", count: "Thick & loaded", img: "uttapam" },
  { name: "Breakfast Specials", count: "Till 11:30 AM", img: "breakfast" },
  { name: "Veg Biryani", count: "Dum-style basmati", img: "biryani" },
  { name: "Fried Rice", count: "Indo-Chinese wok", img: "friedRice" },
  { name: "Noodles", count: "Hakka & Schezwan", img: "noodles" },
  { name: "Chaats", count: "Street classics", img: "chaats" },
  { name: "Snacks", count: "Bajji, bonda & more", img: "snacks" },
  { name: "Kids Favorites", count: "Chocolate dosa & more", img: "kids" },
  { name: "Desserts", count: "Made in-house", img: "desserts" },
  { name: "Beverages", count: "Filter coffee & lassi", img: "beverages" },
];
